import DirectDebitAdd from './direct-debit-add';

export default DirectDebitAdd;
